import Intl from '../Intl';
import {
    getLocale,
    getTimeZone
} from './helpers';
import config from "./config";

let selfs = {
    int: null,
    percent: null,
    currency: {},
    currencyBalance: {},
    date: {}
};

const Self = {
    getCurrency(currency) {
        let self = selfs.currency[currency];

        if (!self) {
            const options = {
                ...config.currency.default,
                ...config.currency[currency],
                currency
            };

            self = selfs.currency[currency] = new Intl.NumberFormat(getLocale(), options);
        }

        return self;
    },

    getCurrencyBalance(currency) {
        let self = selfs.currencyBalance[currency];

        if (!self) {
            const options = {
                ...config.currencyBalance.default,
                ...config.currencyBalance[currency],
                currency
            };

            self = selfs.currencyBalance[currency] = new Intl.NumberFormat(getLocale(), options);
        }

        return self;
    },

    getNumber(key, params) {
        if (!params) {
            if (!selfs[key]) {
                selfs[key] = Intl.NumberFormat(getLocale(), config[key]);
            }

            return selfs[key];
        }

        return Intl.NumberFormat(getLocale(), params);
    },

    getDate(key, timeZone = getTimeZone()) {
        const resolvedTimeZone = getTimeZone(timeZone);
        const keySelf = `${key}-${resolvedTimeZone}`;

        if (!selfs.date[keySelf]) {
            const options = {
                ...config[key],
                timeZone: resolvedTimeZone
            };
            selfs.date[keySelf] = Intl.DateTimeFormat(getLocale(), options);
        }
        return selfs.date[keySelf];
    }
};

export default Self;
